<div id="disabled-background" [ngClass]="{show: isSideNavActive}" class="d-xl-none"></div>
<div class="align-items-center h-100 pb-2"
     id="header-wrapper"
     [ngClass]="{'d-none': shouldHide, 'd-flex': !shouldHide}"
>
  <div class="clr-col-2 clr-col-sm-2 clr-offset-1 d-xl-none" id="menu-trigger"
       (click)="showSideNav($event)"
       [ngClass]="{active: isSideNavActive}"
  >
    <div class="nav-link h-100 d-flex align-items-center justify-content-center">
      <fa-icon icon="bars" class="nav-fa"></fa-icon>
    </div>
  </div>
  <div class="clr-col-2 d-xl-none">
    <app-back-button></app-back-button>
  </div>
  <div class="clr-col-6 d-flex justify-content-xl-start justify-content-end clr-col-xl-2 clr-offset-xl-1 py-2 h-100">
      <a [routerLink]="['/']">
        <img class="logo" src="assets/logo.svg" alt="logo"/>
      </a>
  </div>
  <div class="clr-col-xl-8 d-xl-block d-none p-0">
    <p-menubar [model]="sections">
      <div class="mr-2">
        <app-global-search-input></app-global-search-input>
      </div>
    </p-menubar>
  </div>
</div>
<app-side-navigation
    class="d-xl-none"
    [sections]="sections"
    [ngClass]="{show: isSideNavActive}"
    [currentSection]="currentSection"
    (hide)="isSideNavActive = false"
></app-side-navigation>
